import { QUERY_KEYS } from '../constants/queryKeys';
import { IBuiltCar } from '../../../../common/model/IBuiltCar';
import * as H from 'history';

const queryString = require('query-string');

const carUrlQueryTransformer = {
  toQueryString(customisedCar: IBuiltCar): string {
    const query = queryString.parse(location.search, { arrayFormat: 'comma' });

    if (customisedCar.accessories) {
      query[QUERY_KEYS.ACCESSORIES] = customisedCar.accessories;
    } else {
      delete query[QUERY_KEYS.ACCESSORIES];
    }

    if (customisedCar.packs) {
      query[QUERY_KEYS.PACKS] = customisedCar.packs;
    } else {
      delete query[QUERY_KEYS.PACKS];
    }

    if (customisedCar.servicePlan) {
      query[QUERY_KEYS.SERVICE_PLAN] = customisedCar.servicePlan;
    } else {
      delete query[QUERY_KEYS.SERVICE_PLAN];
    }

    return queryString.stringify(query, { arrayFormat: 'comma' });
  },

  fromQueryString(carId: string, routerLocation?: H.Location): IBuiltCar {
    carId = decodeURIComponent(carId);
    let currentLocation: Location | H.Location = location;
    if (routerLocation) {
      currentLocation = routerLocation;
    }

    const search = queryString.parse(currentLocation.search, { arrayFormat: 'comma' });

    return {
      carId,
      accessories: search[QUERY_KEYS.ACCESSORIES]
        ? Array.isArray(search[QUERY_KEYS.ACCESSORIES])
          ? search[QUERY_KEYS.ACCESSORIES]
          : [search[QUERY_KEYS.ACCESSORIES]]
        : [],
      packs: search[QUERY_KEYS.PACKS]
        ? Array.isArray(search[QUERY_KEYS.PACKS])
          ? search[QUERY_KEYS.PACKS]
          : [search[QUERY_KEYS.PACKS]]
        : [],
      servicePlan: search[QUERY_KEYS.SERVICE_PLAN] ? search[QUERY_KEYS.SERVICE_PLAN] : null,
    };
  },
};

export default carUrlQueryTransformer;
